import { enableProdMode, provideZoneChangeDetection } from "@angular/core";

import { platformBrowser } from "@angular/platform-browser";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
	window.console.log = function () {};
	enableProdMode();
}

console.log("Starting Angular bootstrap...");
platformBrowser()
	.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
	.then(() => console.log("Angular bootstrap successful!"))
	.catch((err) => {
		console.error("Angular bootstrap failed:", err);
		document.body.innerHTML = '<h1 style="color: red;">Bootstrap Error: ' + err.message + "</h1>";
	});
